import type * as Types from '../generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRegistryStoreSectionsQueryVariables = Types.Exact<{
  names?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type GetRegistryStoreSectionsQuery = {
  __typename?: 'Query';
  registryStoreSections: Array<{
    __typename?: 'RegistryStoreSection';
    name: string;
    stores: Array<{
      __typename?: 'RegistryStore';
      id: string;
      name: string;
      sectionName: string;
      shortDescription: string;
      longDescription: string;
      createRegistryUrl: string;
      domain: string;
      hostname: string;
      connectAction: Types.RegistryStoreConnectAction;
      allowCreateBeforeConnect: boolean;
      onlyForEventTypes?: Array<Types.EventType> | null;
      isRecommended: boolean;
      logos: Array<{ __typename?: 'Image'; url: string; mimeType: string }>;
      logosCompact: Array<{ __typename?: 'Image'; url: string; mimeType: string }>;
      valueProps: Array<{ __typename?: 'RegistryStoreValueProposition'; text: string; image: { __typename?: 'Image'; url: string; mimeType: string } }>;
    }>;
  }>;
};

export type GetRegistryProductsDataQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetRegistryProductsDataQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      registry: Array<{
        __typename?: 'Registry';
        id: string;
        nameV0204?: string | null;
        urlV0204?: string | null;
        imageUrlV0204?: string | null;
        wantSync?: boolean | null;
        type: Types.RegistryType;
        isStandalonesType: boolean;
        isSyncingType: boolean;
        isTransferredType: boolean;
        storeName?: string | null;
        cannotSync: boolean;
        hasItems: boolean;
        transferredRegistryData?: {
          __typename?: 'TransferredRegistryData';
          transferredAt: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number };
          lastPublicCheck?: {
            __typename?: 'ExternalRegistryStatusData';
            isPublic: boolean;
            checkedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          } | null;
        } | null;
        lastSyncAt?: { __typename?: 'Date'; timestamp: any } | null;
        items?: Array<{
          __typename?: 'RegistryItem';
          id: string;
          isGroupGiftingEnabled?: boolean | null;
          isGetCashEquivalent?: boolean | null;
          note?: string | null;
          externallyOwned: boolean;
          canEditProductData: boolean;
          storeName?: string | null;
          fpIndex: number;
          stillNeeded: number;
          alreadyPurchased?: number | null;
          alreadyReserved?: number | null;
          totalRequested?: number | null;
          isHidden: boolean;
          mustHave: boolean;
          createAt: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string };
          productData: {
            __typename?: 'RegistryItemProductData';
            brand?: string | null;
            customType?: Types.CustomItemDataType | null;
            title: string;
            externalUrl?: string | null;
            checkoutUrl?: string | null;
            pdpUrl?: string | null;
            description?: string | null;
            isFullPrice: boolean;
            legacyType: Types.LegacyRegistryItemType;
            registryItem: { __typename?: 'RegistryItem'; id: string };
            price?: {
              __typename?: 'RegistryMonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
            } | null;
            fullPrice?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
          };
          donationFund?: {
            __typename?: 'DonationFund';
            id: string;
            fundType: Types.CustomItemDataType;
            suggestedQuantityStillNeeded?: number | null;
            donationsAreCapped: boolean;
            enforceSuggestedDonationAmount: boolean;
            hideFundingGoal: boolean;
            progressToGoalPercent?: number | null;
            fpIndex?: number | null;
            title: string;
            url?: string | null;
            description?: string | null;
            enableCashOrCheck?: boolean | null;
            enableAppPlatform: boolean;
            enableJoyCredit: boolean;
            mustHave: boolean;
            donations: Array<{
              __typename?: 'DonationFundDonation';
              id: string;
              name: string;
              email: string;
              note?: string | null;
              platformType?: Types.DonationFundPaymentMethodEnum | null;
              amount: {
                __typename?: 'MonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'Currency'; code: string; places: number } | null;
              };
              orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
            }>;
            goalMonetaryValue?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            suggestedDonationMonetaryValue?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            platform?: {
              __typename?: 'DonationFundPlatform';
              id?: string | null;
              type: Types.DonationFundPlatformTypeEnum;
              name: string;
              link?: string | null;
              username?: string | null;
            } | null;
            photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            progressToGoal?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            amountTillGoalIsReached?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            currency: { __typename?: 'RegistryCurrency'; code: string; id: string; displayName: string };
          } | null;
        }> | null;
        myReservedOrders: Array<{
          __typename?: 'RegistryOrder';
          id: string;
          name: string;
          email: string;
          note?: string | null;
          isPurchased: boolean;
          isDropship: boolean;
          status?: string | null;
          orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
          orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          lineItems: Array<{
            __typename?: 'LineItem';
            locator: string;
            quantity: number;
            isGetCashEquivalent: boolean;
            lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
            registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
            lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
            annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
            frozenProductData: {
              __typename?: 'RegistrySummaryProductData';
              title: string;
              customType: Types.CustomItemDataType;
              price: {
                __typename?: 'RegistryMonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
              };
              photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            };
          }>;
          fulfillment?: {
            __typename?: 'RegistryFulfillment';
            status: string;
            statusPageUrl?: string | null;
            orderNumber: string;
            shipments?: Array<{
              __typename?: 'RegistryFulfillmentShipment';
              trackingInformation?: {
                __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
                url?: string | null;
                company?: string | null;
                trackingNumber?: string | null;
              } | null;
            }> | null;
          } | null;
          shippingAddress?: {
            __typename?: 'RegistryOrderShippingAddress';
            hash?: string | null;
            name?: string | null;
            address1?: string | null;
            address2?: string | null;
            city?: string | null;
            state?: string | null;
            postalCode?: string | null;
            country?: string | null;
            countryCode?: string | null;
          } | null;
        } | null>;
        myPurchasedOrders: Array<{
          __typename?: 'RegistryOrder';
          id: string;
          name: string;
          email: string;
          note?: string | null;
          isPurchased: boolean;
          isDropship: boolean;
          status?: string | null;
          orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
          orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          lineItems: Array<{
            __typename?: 'LineItem';
            locator: string;
            quantity: number;
            isGetCashEquivalent: boolean;
            lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
            registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
            lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
            annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
            frozenProductData: {
              __typename?: 'RegistrySummaryProductData';
              title: string;
              customType: Types.CustomItemDataType;
              price: {
                __typename?: 'RegistryMonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
              };
              photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            };
          }>;
          fulfillment?: {
            __typename?: 'RegistryFulfillment';
            status: string;
            statusPageUrl?: string | null;
            orderNumber: string;
            shipments?: Array<{
              __typename?: 'RegistryFulfillmentShipment';
              trackingInformation?: {
                __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
                url?: string | null;
                company?: string | null;
                trackingNumber?: string | null;
              } | null;
            }> | null;
          } | null;
          shippingAddress?: {
            __typename?: 'RegistryOrderShippingAddress';
            hash?: string | null;
            name?: string | null;
            address1?: string | null;
            address2?: string | null;
            city?: string | null;
            state?: string | null;
            postalCode?: string | null;
            country?: string | null;
            countryCode?: string | null;
          } | null;
        } | null>;
        mySession?: { __typename?: 'RegistrySession'; email: string } | null;
      }>;
    };
  } | null;
};

export type GetRegistryPageQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRegistryPageQuery = {
  __typename?: 'Query';
  registryPage?: {
    __typename?: 'RegistryPage';
    photo?: {
      __typename?: 'Photo';
      id: string;
      url: string;
      width: number;
      height: number;
      blurHash?: string | null;
      altTag?: string | null;
      layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string };
      transform?: { __typename?: 'PhotoTransform'; x?: number | null; y?: number | null } | null;
    } | null;
  } | null;
};

export type CheckRegistryUrlCanSyncQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;

export type CheckRegistryUrlCanSyncQuery = { __typename?: 'Query'; checkRegistryUrlCanSync?: boolean | null };

export type CheckRegistryUrlQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;

export type CheckRegistryUrlQuery = { __typename?: 'Query'; checkRegistryUrl: { __typename?: 'CheckRegistryUrlResult'; canSync: boolean; canTransfer: boolean } };

export type RegistryOrderByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type RegistryOrderByIdQuery = {
  __typename?: 'Query';
  registryOrderById?: {
    __typename?: 'RegistryOrder';
    id: string;
    email: string;
    name: string;
    isPurchased: boolean;
    isDropship: boolean;
    lineItems: Array<{
      __typename?: 'LineItem';
      locator: string;
      quantity: number;
      isGetCashEquivalent: boolean;
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
      lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
      annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
      frozenProductData: {
        __typename?: 'RegistrySummaryProductData';
        title: string;
        customType: Types.CustomItemDataType;
        price: {
          __typename?: 'RegistryMonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
        };
        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      };
    }>;
  } | null;
};

export type GetRegistryOrdersCheckoutMechanismsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  shippingAddress?: Types.InputMaybe<Types.ShippingAddressInput>;
}>;

export type GetRegistryOrdersCheckoutMechanismsQuery = {
  __typename?: 'Query';
  registryOrdersByIds: Array<{
    __typename?: 'RegistryOrder';
    id: string;
    lineItems: Array<{
      __typename?: 'LineItem';
      locator: string;
      quantity: number;
      registryItem?: {
        __typename?: 'RegistryItem';
        id: string;
        productData: {
          __typename?: 'RegistryItemProductData';
          title: string;
          registryItem: { __typename?: 'RegistryItem'; id: string };
          checkoutMechanisms: Array<{
            __typename?: 'CheckoutMechanism';
            type: string;
            hideValueProps: boolean;
            checkoutFailureCode?: string | null;
            checkoutWarningCodes: Array<string>;
          }>;
        };
      } | null;
    }>;
  } | null>;
};

export type GetItemCheckoutMechanismsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  shippingAddress?: Types.InputMaybe<Types.ShippingAddressInput>;
  requestedQty?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type GetItemCheckoutMechanismsQuery = {
  __typename?: 'Query';
  registryItem?: {
    __typename?: 'RegistryItem';
    id: string;
    productData: {
      __typename?: 'RegistryItemProductData';
      registryItem: { __typename?: 'RegistryItem'; id: string };
      checkoutMechanisms: Array<{
        __typename?: 'CheckoutMechanism';
        type: string;
        hideValueProps: boolean;
        checkoutFailureCode?: string | null;
        checkoutWarningCodes: Array<string>;
      }>;
    };
  } | null;
};

export type CardPaymentMethodFragment = { __typename?: 'PaymentMethod'; card?: { __typename?: 'PaymentCard'; brand: string; last4: string } | null };

export type GetRegistryPurchaseConfirmationDetailsQueryVariables = Types.Exact<{
  purchaseContextId: Types.Scalars['ID'];
}>;

export type GetRegistryPurchaseConfirmationDetailsQuery = {
  __typename?: 'Query';
  registryPurchaseConfirmationDetailsByPurchaseContextId?: {
    __typename?: 'RegistryPurchaseConfirmationDetails';
    salesOrder?: {
      __typename?: 'SalesOrder';
      id: string;
      sender?: { __typename?: 'RegistryCustomer'; email: string; name: string } | null;
      subtotal: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      total: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      taxesTotal: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      shippingAndHandlingTotal: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      orderChargesTotal: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      postPurchaseFeesTotal: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      compensationTotal: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      items: Array<{
        __typename: 'SalesOrderItemLine';
        isEdelivery: boolean;
        quantity: number;
        isCashFund: boolean;
        title: string;
        unitValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
        lineValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      }>;
      taxes: Array<{
        __typename: 'SalesOrderTaxLine';
        title: string;
        lineValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      }>;
      shippingAndHandling: Array<{
        __typename: 'SalesOrderShippingAndHandlingLine';
        title: string;
        lineValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      }>;
      orderCharges: Array<{
        __typename: 'SalesOrderChargeLine';
        title: string;
        lineValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      }>;
      postPurchaseFees: Array<{
        __typename: 'SalesOrderPostPurchaseFeeLine';
        title: string;
        lineValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      }>;
      compensation: Array<{
        __typename: 'SalesOrderCompensationLine';
        title: string;
        lineValue: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      }>;
      paymentMethod?: { __typename?: 'PaymentMethod'; card?: { __typename?: 'PaymentCard'; brand: string; last4: string } | null } | null;
    } | null;
  } | null;
};

export type GetRegistryStaticDataQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetRegistryStaticDataQuery = {
  __typename?: 'Query';
  getRegistryStaticData?: {
    __typename?: 'RegistryStaticData';
    countries?: {
      __typename?: 'RegistryCountryResults';
      topRanked: Array<{ __typename?: 'RegistryCountry'; name: string; code: string }>;
      ordered: Array<{ __typename?: 'RegistryCountry'; name: string; code: string }>;
    } | null;
  } | null;
};

export type GetRegistryOrderByIdQueryVariables = Types.Exact<{
  registryOrderId: Types.Scalars['ID'];
}>;

export type GetRegistryOrderByIdQuery = {
  __typename?: 'Query';
  registryOrderById?: {
    __typename?: 'RegistryOrder';
    id: string;
    name: string;
    email: string;
    lineItems: Array<{
      __typename?: 'LineItem';
      quantity: number;
      registryItem?: {
        __typename?: 'RegistryItem';
        id: string;
        alreadyReserved?: number | null;
        alreadyPurchased?: number | null;
        productData: {
          __typename?: 'RegistryItemProductData';
          title: string;
          registryItem: { __typename?: 'RegistryItem'; id: string };
          photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
        };
      } | null;
    }>;
  } | null;
};

export type GetDonationFundDonationByIdQueryVariables = Types.Exact<{
  registryOrderId: Types.Scalars['ID'];
}>;

export type GetDonationFundDonationByIdQuery = {
  __typename?: 'Query';
  getDonationFundDonationById?: {
    __typename?: 'DonationFundDonation';
    id: string;
    name: string;
    email: string;
    note?: string | null;
    platformType?: Types.DonationFundPaymentMethodEnum | null;
    amount: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    };
    orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
  } | null;
};

export type GetRegistryOnboardingSuggestionsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRegistryOnboardingSuggestionsQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'User'; id: string; emailIsVerified: boolean } | null;
  eventById?: {
    __typename?: 'Event';
    id: string;
    website: string;
    suggestion: {
      __typename?: 'EventSuggestionInfo';
      items: Array<{
        __typename?: 'EventSuggestion';
        id: string;
        identifier: string;
        stateJSON?: any | null;
        createdAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
        offeredAt?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
      }>;
    };
    eventUsers: Array<{ __typename?: 'EventUser'; id: string }>;
    info: {
      __typename?: 'EventInfo';
      id: string;
      greeting?: string | null;
      locationInfo?: { __typename?: 'EventLocation'; id?: string | null; country?: string | null } | null;
      finalizedDate?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
      registry: Array<{
        __typename?: 'Registry';
        id: string;
        storeName?: string | null;
        items?: Array<{
          __typename?: 'RegistryItem';
          id: string;
          externallyOwned: boolean;
          productData: { __typename?: 'RegistryItemProductData'; customType?: Types.CustomItemDataType | null; registryItem: { __typename?: 'RegistryItem'; id: string } };
        }> | null;
      }>;
    };
    registryPageInfo?: {
      __typename?: 'EventPageInfo';
      id: string;
      page: {
        __typename?: 'EventPage';
        id: string;
        disabled: boolean;
        pageSubtitle?: string | null;
        photoV2?: { __typename?: 'DefaultPagePhoto'; id: string; url: string } | { __typename?: 'Photo'; id: string; url: string } | null;
      };
    } | null;
    registry: {
      __typename?: 'EventData';
      id: string;
      currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; isDefault: boolean; displayName: string; rank?: number | null } | null;
      shippingAddress?: {
        __typename?: 'ShippingAddress';
        name?: string | null;
        address1: string;
        address2?: string | null;
        phone?: string | null;
        city: string;
        state: string;
        postalCode?: string | null;
        country: string;
        countryCode?: string | null;
        validated: boolean;
        hash?: string | null;
      } | null;
    };
  } | null;
  registryPage?: { __typename?: 'RegistryPage'; photo?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
};

export type GetRegistrySettingsDialogDataQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRegistrySettingsDialogDataQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    website: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventDateIsFinalized: boolean;
      tentativeDate?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
    };
  } | null;
};

export type GetProductVerticalConfigQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetProductVerticalConfigQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      id: string;
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
  } | null;
};

export type GetVisibilityConfigQueryVariables = Types.Exact<{
  eventPageId: Types.Scalars['ID'];
  eventId: Types.Scalars['ID'];
}>;

export type GetVisibilityConfigQuery = {
  __typename?: 'Query';
  eventPage?: { __typename?: 'EventPage'; id: string; disabled: boolean; private: boolean } | null;
  event?: { __typename?: 'Event'; id: string; info: { __typename?: 'EventInfo'; id: string; eventPassword?: string | null } } | null;
};

export type GetPayoutAccountInfoQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetPayoutAccountInfoQuery = {
  __typename?: 'Query';
  getRegistryEventData?: {
    __typename?: 'EventData';
    id: string;
    payoutAccount?: {
      __typename?: 'RegistryPayoutAccount';
      status: string;
      currencyCode: string;
      statusDetails?: string | null;
      onboardingUrl?: string | null;
      serviceDashboardUrl?: string | null;
      externalAccountLast4?: string | null;
      balance?: {
        __typename?: 'RegistryPayoutAccountBalance';
        availablePending: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMajorUnits: number; valueInMinorUnits: number };
        available: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMajorUnits: number; valueInMinorUnits: number };
        withdrawnPending: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMajorUnits: number; valueInMinorUnits: number };
        withdrawn: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMajorUnits: number; valueInMinorUnits: number };
        received: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMajorUnits: number; valueInMinorUnits: number };
      } | null;
      withdrawals: Array<{
        __typename?: 'RegistryPayoutAccountWithdrawal';
        id: string;
        status: string;
        totalValue: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMajorUnits: number; valueInMinorUnits: number };
        createdAt: { __typename?: 'Date'; timestamp: any };
      }>;
    } | null;
  } | null;
};

export type GetCalculateRegistryPurchaseInfoQueryVariables = Types.Exact<{
  payload: Types.CalculateRegistryPurchaseInfoInput;
}>;

export type GetCalculateRegistryPurchaseInfoQuery = {
  __typename?: 'Query';
  calculateRegistryPurchaseInfo: {
    __typename?: 'CalculateRegistryPurchaseInfo';
    checkoutWarningCodes: Array<string>;
    shippingAndHandling: Array<{
      __typename: 'SalesOrderShippingAndHandlingLine';
      title: string;
      lineValue: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    }>;
    orderCharges: Array<{
      __typename: 'SalesOrderChargeLine';
      title: string;
      lineValue: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    }>;
    postPurchaseFees: Array<{
      __typename: 'SalesOrderPostPurchaseFeeLine';
      title: string;
      lineValue: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    }>;
    compensation: Array<{
      __typename: 'SalesOrderCompensationLine';
      title: string;
      lineValue: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    }>;
    shippingAndHandlingTotal: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    };
  };
};

export type GetRegistryTransferredSyncInformationQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetRegistryTransferredSyncInformationQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: { __typename?: 'EventInfo'; id: string; registry: Array<{ __typename?: 'Registry'; id: string; isSyncingType: boolean; isTransferredType: boolean }> };
  } | null;
};

export type GetRegistryJoyCreditStatusQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRegistryJoyCreditStatusQuery = {
  __typename?: 'Query';
  getRegistryEventData?: {
    __typename?: 'EventData';
    id: string;
    joyCreditStatus: {
      __typename?: 'RegistryJoyCreditStatus';
      joyCredit?: {
        __typename?: 'RegistryJoyCredit';
        active: boolean;
        code?: string | null;
        amount?: { __typename?: 'CommerceMonetaryValue'; currencyCode: string; valueInMinorUnits: number } | null;
      } | null;
    };
  } | null;
};

export const CardPaymentMethodFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardPaymentMethod' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentMethod' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'card' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetRegistryStoreSectionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryStoreSections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'names' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryStoreSections' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'names' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'names' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stores' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryStore' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryStore' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryStore' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sectionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createRegistryUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'connectAction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCreateBeforeConnect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onlyForEventTypes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRecommended' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logosCompact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'valueProps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryStoreSectionsQuery__
 *
 * To run a query within a React component, call `useGetRegistryStoreSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryStoreSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryStoreSectionsQuery({
 *   variables: {
 *      names: // value for 'names'
 *   },
 * });
 */
export function useGetRegistryStoreSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>(GetRegistryStoreSectionsDocument, baseOptions);
}
export function useGetRegistryStoreSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>(GetRegistryStoreSectionsDocument, baseOptions);
}
export type GetRegistryStoreSectionsQueryHookResult = ReturnType<typeof useGetRegistryStoreSectionsQuery>;
export type GetRegistryStoreSectionsLazyQueryHookResult = ReturnType<typeof useGetRegistryStoreSectionsLazyQuery>;
export type GetRegistryStoreSectionsQueryResult = Apollo.QueryResult<GetRegistryStoreSectionsQuery, GetRegistryStoreSectionsQueryVariables>;
export const GetRegistryProductsDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryProductsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'info' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'registry' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Registry' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Registry' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urlV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrlV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wantSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStandalonesType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSyncingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTransferredType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferredRegistryData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transferredAt' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastPublicCheck' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkedAt' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cannotSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasItems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSyncAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myReservedOrders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPurchasedOrders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySession' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'email' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGroupGiftingEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externallyOwned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditProductData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registryItem' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'price' },
                  name: { kind: 'Name', value: 'priceAugmented' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalRequested' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donationFund' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFund' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFund' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundDonation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fundType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'goalMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedDonationMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedQuantityStillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'donationsAreCapped' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enforceSuggestedDonationAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideFundingGoal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundPlatform' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progressToGoal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountTillGoalIsReached' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'progressToGoalPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableCashOrCheck' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableAppPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJoyCredit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundDonation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundDonation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platformType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundPlatform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundPlatform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'link' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryOrder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDropship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LineItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fulfillment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LineItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LineItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'locator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryItem' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItemData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationFundPlatformType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'correctedQuantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'frozenProductData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipments' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackingInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryProductsDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryProductsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryProductsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryProductsDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryProductsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>(GetRegistryProductsDataDocument, baseOptions);
}
export function useGetRegistryProductsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>(GetRegistryProductsDataDocument, baseOptions);
}
export type GetRegistryProductsDataQueryHookResult = ReturnType<typeof useGetRegistryProductsDataQuery>;
export type GetRegistryProductsDataLazyQueryHookResult = ReturnType<typeof useGetRegistryProductsDataLazyQuery>;
export type GetRegistryProductsDataQueryResult = Apollo.QueryResult<GetRegistryProductsDataQuery, GetRegistryProductsDataQueryVariables>;
export const GetRegistryPageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryPage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Photo' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Photo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurHash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoTransform' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoTransform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PhotoTransform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryPageQuery__
 *
 * To run a query within a React component, call `useGetRegistryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryPageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryPageQuery, GetRegistryPageQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryPageQuery, GetRegistryPageQueryVariables>(GetRegistryPageDocument, baseOptions);
}
export function useGetRegistryPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryPageQuery, GetRegistryPageQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRegistryPageQuery, GetRegistryPageQueryVariables>(GetRegistryPageDocument, baseOptions);
}
export type GetRegistryPageQueryHookResult = ReturnType<typeof useGetRegistryPageQuery>;
export type GetRegistryPageLazyQueryHookResult = ReturnType<typeof useGetRegistryPageLazyQuery>;
export type GetRegistryPageQueryResult = Apollo.QueryResult<GetRegistryPageQuery, GetRegistryPageQueryVariables>;
export const CheckRegistryUrlCanSyncDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckRegistryUrlCanSync' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkRegistryUrlCanSync' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'url' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCheckRegistryUrlCanSyncQuery__
 *
 * To run a query within a React component, call `useCheckRegistryUrlCanSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRegistryUrlCanSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRegistryUrlCanSyncQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckRegistryUrlCanSyncQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>) {
  return ApolloReactHooks.useQuery<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>(CheckRegistryUrlCanSyncDocument, baseOptions);
}
export function useCheckRegistryUrlCanSyncLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>(CheckRegistryUrlCanSyncDocument, baseOptions);
}
export type CheckRegistryUrlCanSyncQueryHookResult = ReturnType<typeof useCheckRegistryUrlCanSyncQuery>;
export type CheckRegistryUrlCanSyncLazyQueryHookResult = ReturnType<typeof useCheckRegistryUrlCanSyncLazyQuery>;
export type CheckRegistryUrlCanSyncQueryResult = Apollo.QueryResult<CheckRegistryUrlCanSyncQuery, CheckRegistryUrlCanSyncQueryVariables>;
export const CheckRegistryUrlDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckRegistryUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkRegistryUrl' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'url' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'canSync' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canTransfer' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCheckRegistryUrlQuery__
 *
 * To run a query within a React component, call `useCheckRegistryUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRegistryUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRegistryUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckRegistryUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>) {
  return ApolloReactHooks.useQuery<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>(CheckRegistryUrlDocument, baseOptions);
}
export function useCheckRegistryUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>(CheckRegistryUrlDocument, baseOptions);
}
export type CheckRegistryUrlQueryHookResult = ReturnType<typeof useCheckRegistryUrlQuery>;
export type CheckRegistryUrlLazyQueryHookResult = ReturnType<typeof useCheckRegistryUrlLazyQuery>;
export type CheckRegistryUrlQueryResult = Apollo.QueryResult<CheckRegistryUrlQuery, CheckRegistryUrlQueryVariables>;
export const RegistryOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RegistryOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDropship' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lineItems' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LineItem' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LineItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LineItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'locator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryItem' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItemData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationFundPlatformType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'correctedQuantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'frozenProductData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRegistryOrderByIdQuery__
 *
 * To run a query within a React component, call `useRegistryOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistryOrderByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>(RegistryOrderByIdDocument, baseOptions);
}
export function useRegistryOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>(RegistryOrderByIdDocument, baseOptions);
}
export type RegistryOrderByIdQueryHookResult = ReturnType<typeof useRegistryOrderByIdQuery>;
export type RegistryOrderByIdLazyQueryHookResult = ReturnType<typeof useRegistryOrderByIdLazyQuery>;
export type RegistryOrderByIdQueryResult = Apollo.QueryResult<RegistryOrderByIdQuery, RegistryOrderByIdQueryVariables>;
export const GetRegistryOrdersCheckoutMechanismsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryOrdersCheckoutMechanisms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingAddressInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryOrdersByIds' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'ids' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lineItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'locator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registryItem' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'registryItem' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'checkoutMechanisms' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'shippingAddress' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
                                      },
                                    ],
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CheckoutMechanismType' } }] },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CheckoutMechanismType' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CheckoutMechanism' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideValueProps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutFailureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutWarningCodes' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryOrdersCheckoutMechanismsQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrdersCheckoutMechanismsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrdersCheckoutMechanismsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrdersCheckoutMechanismsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useGetRegistryOrdersCheckoutMechanismsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>(
    GetRegistryOrdersCheckoutMechanismsDocument,
    baseOptions,
  );
}
export function useGetRegistryOrdersCheckoutMechanismsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>(
    GetRegistryOrdersCheckoutMechanismsDocument,
    baseOptions,
  );
}
export type GetRegistryOrdersCheckoutMechanismsQueryHookResult = ReturnType<typeof useGetRegistryOrdersCheckoutMechanismsQuery>;
export type GetRegistryOrdersCheckoutMechanismsLazyQueryHookResult = ReturnType<typeof useGetRegistryOrdersCheckoutMechanismsLazyQuery>;
export type GetRegistryOrdersCheckoutMechanismsQueryResult = Apollo.QueryResult<GetRegistryOrdersCheckoutMechanismsQuery, GetRegistryOrdersCheckoutMechanismsQueryVariables>;
export const GetItemCheckoutMechanismsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetItemCheckoutMechanisms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShippingAddressInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'requestedQty' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryItem' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registryItem' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkoutMechanisms' },
                        arguments: [
                          { kind: 'Argument', name: { kind: 'Name', value: 'shippingAddress' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'shippingAddress' } } },
                          { kind: 'Argument', name: { kind: 'Name', value: 'requestedQty' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'requestedQty' } } },
                        ],
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CheckoutMechanismType' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CheckoutMechanismType' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CheckoutMechanism' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideValueProps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutFailureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutWarningCodes' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetItemCheckoutMechanismsQuery__
 *
 * To run a query within a React component, call `useGetItemCheckoutMechanismsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemCheckoutMechanismsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemCheckoutMechanismsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shippingAddress: // value for 'shippingAddress'
 *      requestedQty: // value for 'requestedQty'
 *   },
 * });
 */
export function useGetItemCheckoutMechanismsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>(GetItemCheckoutMechanismsDocument, baseOptions);
}
export function useGetItemCheckoutMechanismsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>(GetItemCheckoutMechanismsDocument, baseOptions);
}
export type GetItemCheckoutMechanismsQueryHookResult = ReturnType<typeof useGetItemCheckoutMechanismsQuery>;
export type GetItemCheckoutMechanismsLazyQueryHookResult = ReturnType<typeof useGetItemCheckoutMechanismsLazyQuery>;
export type GetItemCheckoutMechanismsQueryResult = Apollo.QueryResult<GetItemCheckoutMechanismsQuery, GetItemCheckoutMechanismsQueryVariables>;
export const GetRegistryPurchaseConfirmationDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryPurchaseConfirmationDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'purchaseContextId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryPurchaseConfirmationDetailsByPurchaseContextId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purchaseContextId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'purchaseContextId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'salesOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtotal' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxesTotal' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shippingAndHandlingTotal' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderChargesTotal' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postPurchaseFeesTotal' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'compensationTotal' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderTags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unitValue' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photos' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCashFund' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxes' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shippingAndHandling' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderCharges' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postPurchaseFees' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'compensation' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethod' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CardPaymentMethod' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardPaymentMethod' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentMethod' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'card' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesOrderLine' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SalesOrderLine' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryPurchaseConfirmationDetailsQuery__
 *
 * To run a query within a React component, call `useGetRegistryPurchaseConfirmationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryPurchaseConfirmationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryPurchaseConfirmationDetailsQuery({
 *   variables: {
 *      purchaseContextId: // value for 'purchaseContextId'
 *   },
 * });
 */
export function useGetRegistryPurchaseConfirmationDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>(
    GetRegistryPurchaseConfirmationDetailsDocument,
    baseOptions,
  );
}
export function useGetRegistryPurchaseConfirmationDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryPurchaseConfirmationDetailsQuery, GetRegistryPurchaseConfirmationDetailsQueryVariables>(
    GetRegistryPurchaseConfirmationDetailsDocument,
    baseOptions,
  );
}
export type GetRegistryPurchaseConfirmationDetailsQueryHookResult = ReturnType<typeof useGetRegistryPurchaseConfirmationDetailsQuery>;
export type GetRegistryPurchaseConfirmationDetailsLazyQueryHookResult = ReturnType<typeof useGetRegistryPurchaseConfirmationDetailsLazyQuery>;
export type GetRegistryPurchaseConfirmationDetailsQueryResult = Apollo.QueryResult<
  GetRegistryPurchaseConfirmationDetailsQuery,
  GetRegistryPurchaseConfirmationDetailsQueryVariables
>;
export const GetRegistryStaticDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryStaticData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryStaticData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRanked' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordered' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryStaticDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryStaticDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryStaticDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryStaticDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegistryStaticDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>(GetRegistryStaticDataDocument, baseOptions);
}
export function useGetRegistryStaticDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>(GetRegistryStaticDataDocument, baseOptions);
}
export type GetRegistryStaticDataQueryHookResult = ReturnType<typeof useGetRegistryStaticDataQuery>;
export type GetRegistryStaticDataLazyQueryHookResult = ReturnType<typeof useGetRegistryStaticDataLazyQuery>;
export type GetRegistryStaticDataQueryResult = Apollo.QueryResult<GetRegistryStaticDataQuery, GetRegistryStaticDataQueryVariables>;
export const GetRegistryOrderByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryOrderById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'registryOrderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryOrderById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'registryOrderId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lineItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registryItem' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alreadyReserved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alreadyPurchased' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productData' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'registryItem' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photos' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetRegistryOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOrderByIdQuery({
 *   variables: {
 *      registryOrderId: // value for 'registryOrderId'
 *   },
 * });
 */
export function useGetRegistryOrderByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>(GetRegistryOrderByIdDocument, baseOptions);
}
export function useGetRegistryOrderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>(GetRegistryOrderByIdDocument, baseOptions);
}
export type GetRegistryOrderByIdQueryHookResult = ReturnType<typeof useGetRegistryOrderByIdQuery>;
export type GetRegistryOrderByIdLazyQueryHookResult = ReturnType<typeof useGetRegistryOrderByIdLazyQuery>;
export type GetRegistryOrderByIdQueryResult = Apollo.QueryResult<GetRegistryOrderByIdQuery, GetRegistryOrderByIdQueryVariables>;
export const GetDonationFundDonationByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDonationFundDonationById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'registryOrderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDonationFundDonationById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'registryOrderId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundDonation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundDonation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundDonation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platformType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDonationFundDonationByIdQuery__
 *
 * To run a query within a React component, call `useGetDonationFundDonationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonationFundDonationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonationFundDonationByIdQuery({
 *   variables: {
 *      registryOrderId: // value for 'registryOrderId'
 *   },
 * });
 */
export function useGetDonationFundDonationByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>(GetDonationFundDonationByIdDocument, baseOptions);
}
export function useGetDonationFundDonationByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>(GetDonationFundDonationByIdDocument, baseOptions);
}
export type GetDonationFundDonationByIdQueryHookResult = ReturnType<typeof useGetDonationFundDonationByIdQuery>;
export type GetDonationFundDonationByIdLazyQueryHookResult = ReturnType<typeof useGetDonationFundDonationByIdLazyQuery>;
export type GetDonationFundDonationByIdQueryResult = Apollo.QueryResult<GetDonationFundDonationByIdQuery, GetDonationFundDonationByIdQueryVariables>;
export const GetRegistryOnboardingSuggestionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryOnboardingSuggestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailIsVerified' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'liveQuery' }, value: { kind: 'BooleanValue', value: true } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventSuggestion' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventUsers' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedDate' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registry' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externallyOwned' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'productData' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'registryItem' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'registryPageInfo' },
                  name: { kind: 'Name', value: 'pageInfo' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'registry' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'page' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                            { kind: 'Field', alias: { kind: 'Name', value: 'pageSubtitle' }, name: { kind: 'Name', value: 'pageSubTitleV0918' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoV2' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryShippingAddressFragment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryPage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventSuggestion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSuggestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offeredAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'stateJSON' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryShippingAddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shippingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventRegistryCurrency' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventRegistryCurrency' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryCurrency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryCurrencyCodes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryCurrencyCodes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryCurrency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryOnboardingSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetRegistryOnboardingSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryOnboardingSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryOnboardingSuggestionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryOnboardingSuggestionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>(GetRegistryOnboardingSuggestionsDocument, baseOptions);
}
export function useGetRegistryOnboardingSuggestionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>(
    GetRegistryOnboardingSuggestionsDocument,
    baseOptions,
  );
}
export type GetRegistryOnboardingSuggestionsQueryHookResult = ReturnType<typeof useGetRegistryOnboardingSuggestionsQuery>;
export type GetRegistryOnboardingSuggestionsLazyQueryHookResult = ReturnType<typeof useGetRegistryOnboardingSuggestionsLazyQuery>;
export type GetRegistryOnboardingSuggestionsQueryResult = Apollo.QueryResult<GetRegistryOnboardingSuggestionsQuery, GetRegistryOnboardingSuggestionsQueryVariables>;
export const GetRegistrySettingsDialogDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistrySettingsDialogData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tentativeDate' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedDate' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDateIsFinalized' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistrySettingsDialogDataQuery__
 *
 * To run a query within a React component, call `useGetRegistrySettingsDialogDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrySettingsDialogDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrySettingsDialogDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistrySettingsDialogDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>(GetRegistrySettingsDialogDataDocument, baseOptions);
}
export function useGetRegistrySettingsDialogDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>(GetRegistrySettingsDialogDataDocument, baseOptions);
}
export type GetRegistrySettingsDialogDataQueryHookResult = ReturnType<typeof useGetRegistrySettingsDialogDataQuery>;
export type GetRegistrySettingsDialogDataLazyQueryHookResult = ReturnType<typeof useGetRegistrySettingsDialogDataLazyQuery>;
export type GetRegistrySettingsDialogDataQueryResult = Apollo.QueryResult<GetRegistrySettingsDialogDataQuery, GetRegistrySettingsDialogDataQueryVariables>;
export const GetProductVerticalConfigDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetProductVerticalConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productVerticals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetProductVerticalConfigQuery__
 *
 * To run a query within a React component, call `useGetProductVerticalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVerticalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVerticalConfigQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetProductVerticalConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>) {
  return ApolloReactHooks.useQuery<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>(GetProductVerticalConfigDocument, baseOptions);
}
export function useGetProductVerticalConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>(GetProductVerticalConfigDocument, baseOptions);
}
export type GetProductVerticalConfigQueryHookResult = ReturnType<typeof useGetProductVerticalConfigQuery>;
export type GetProductVerticalConfigLazyQueryHookResult = ReturnType<typeof useGetProductVerticalConfigLazyQuery>;
export type GetProductVerticalConfigQueryResult = Apollo.QueryResult<GetProductVerticalConfigQuery, GetProductVerticalConfigQueryVariables>;
export const GetVisibilityConfigDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetVisibilityConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventPageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPage' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventPageId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'private' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventPassword' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetVisibilityConfigQuery__
 *
 * To run a query within a React component, call `useGetVisibilityConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibilityConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibilityConfigQuery({
 *   variables: {
 *      eventPageId: // value for 'eventPageId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetVisibilityConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>) {
  return ApolloReactHooks.useQuery<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>(GetVisibilityConfigDocument, baseOptions);
}
export function useGetVisibilityConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>(GetVisibilityConfigDocument, baseOptions);
}
export type GetVisibilityConfigQueryHookResult = ReturnType<typeof useGetVisibilityConfigQuery>;
export type GetVisibilityConfigLazyQueryHookResult = ReturnType<typeof useGetVisibilityConfigLazyQuery>;
export type GetVisibilityConfigQueryResult = Apollo.QueryResult<GetVisibilityConfigQuery, GetVisibilityConfigQueryVariables>;
export const GetPayoutAccountInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayoutAccountInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventPayoutAccount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventPayoutAccount' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payoutAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statusDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onboardingUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceDashboardUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalAccountLast4' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'balance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availablePending' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryMonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'available' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryMonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'withdrawnPending' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryMonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'withdrawn' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryMonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'received' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryMonetaryValue' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'withdrawals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalValue' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryMonetaryValue' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryMonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CommerceMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMajorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPayoutAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetPayoutAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutAccountInfoQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetPayoutAccountInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>(GetPayoutAccountInfoDocument, baseOptions);
}
export function useGetPayoutAccountInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>(GetPayoutAccountInfoDocument, baseOptions);
}
export type GetPayoutAccountInfoQueryHookResult = ReturnType<typeof useGetPayoutAccountInfoQuery>;
export type GetPayoutAccountInfoLazyQueryHookResult = ReturnType<typeof useGetPayoutAccountInfoLazyQuery>;
export type GetPayoutAccountInfoQueryResult = Apollo.QueryResult<GetPayoutAccountInfoQuery, GetPayoutAccountInfoQueryVariables>;
export const GetCalculateRegistryPurchaseInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCalculateRegistryPurchaseInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalculateRegistryPurchaseInfoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calculateRegistryPurchaseInfo' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CalculateRegistryPurchaseInfoFragment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesOrderLine' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SalesOrderLine' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalculateRegistryPurchaseInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalculateRegistryPurchaseInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAndHandling' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderCharges' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postPurchaseFees' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compensation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SalesOrderLine' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAndHandlingTotal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkoutWarningCodes' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCalculateRegistryPurchaseInfoQuery__
 *
 * To run a query within a React component, call `useGetCalculateRegistryPurchaseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculateRegistryPurchaseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculateRegistryPurchaseInfoQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetCalculateRegistryPurchaseInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>(GetCalculateRegistryPurchaseInfoDocument, baseOptions);
}
export function useGetCalculateRegistryPurchaseInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>(
    GetCalculateRegistryPurchaseInfoDocument,
    baseOptions,
  );
}
export type GetCalculateRegistryPurchaseInfoQueryHookResult = ReturnType<typeof useGetCalculateRegistryPurchaseInfoQuery>;
export type GetCalculateRegistryPurchaseInfoLazyQueryHookResult = ReturnType<typeof useGetCalculateRegistryPurchaseInfoLazyQuery>;
export type GetCalculateRegistryPurchaseInfoQueryResult = Apollo.QueryResult<GetCalculateRegistryPurchaseInfoQuery, GetCalculateRegistryPurchaseInfoQueryVariables>;
export const GetRegistryTransferredSyncInformationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryTransferredSyncInformation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registry' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSyncingType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTransferredType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryTransferredSyncInformationQuery__
 *
 * To run a query within a React component, call `useGetRegistryTransferredSyncInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryTransferredSyncInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryTransferredSyncInformationQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryTransferredSyncInformationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>(
    GetRegistryTransferredSyncInformationDocument,
    baseOptions,
  );
}
export function useGetRegistryTransferredSyncInformationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>(
    GetRegistryTransferredSyncInformationDocument,
    baseOptions,
  );
}
export type GetRegistryTransferredSyncInformationQueryHookResult = ReturnType<typeof useGetRegistryTransferredSyncInformationQuery>;
export type GetRegistryTransferredSyncInformationLazyQueryHookResult = ReturnType<typeof useGetRegistryTransferredSyncInformationLazyQuery>;
export type GetRegistryTransferredSyncInformationQueryResult = Apollo.QueryResult<GetRegistryTransferredSyncInformationQuery, GetRegistryTransferredSyncInformationQueryVariables>;
export const GetRegistryJoyCreditStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryJoyCreditStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'joyCreditStatus' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'joyCredit' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'JoyCreditStatus' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JoyCreditStatus' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryJoyCredit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryJoyCreditStatusQuery__
 *
 * To run a query within a React component, call `useGetRegistryJoyCreditStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryJoyCreditStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryJoyCreditStatusQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryJoyCreditStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>(GetRegistryJoyCreditStatusDocument, baseOptions);
}
export function useGetRegistryJoyCreditStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>(GetRegistryJoyCreditStatusDocument, baseOptions);
}
export type GetRegistryJoyCreditStatusQueryHookResult = ReturnType<typeof useGetRegistryJoyCreditStatusQuery>;
export type GetRegistryJoyCreditStatusLazyQueryHookResult = ReturnType<typeof useGetRegistryJoyCreditStatusLazyQuery>;
export type GetRegistryJoyCreditStatusQueryResult = Apollo.QueryResult<GetRegistryJoyCreditStatusQuery, GetRegistryJoyCreditStatusQueryVariables>;
